import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/resourceicon.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import { data } from "react-router";
import noimage from '../images/noimage.jpeg';
import loadIcon from '../images/loader2.webp';
import { connect } from "react-redux";
const MeetingRooms=({commonData})=>
{
    const [show,setShow]=useState(false);
    const [progress,setProgress]=useState(false);
    const [msg,setMsg]=useState("");
    const [resourcedata,setResourceData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({id:"",facilityid:"",abbr:"",name:"",description:"",ismeetingroom:"",rtype:"",photo1:"",photo2:"",photo3:""});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);    
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Facility", key: "facilityname", sortable: true},
        { name: "Name", key: "name", sortable: true },        
        { name: "Details", key: "details", sortable: true },
        { name: "Booking Amount", key: "amount", sortable: true },
        { name: "Image 1", key: "photo1", sortable: false},      
        { name: "Image 2", key: "photo2", sortable: false},
        { name: "Image 3", key: "photo3", sortable: false},                        
    ];
    function addResource(event)
    {
        if(commonData.utype.toLowerCase()=="franchisee")
        {
            alert("You Don't have rights!!!");
            return;
        }
        setFormData({id:"",facilityid:"",abbr:"",name:"",description:"",ismeetingroom:"",rtype:"",photo1:"",photo2:"",photo3:""});
        setShow(true);
        setMsg("");
    }
    async function saveData(event)
    {
        if(commonData.utype.toLowerCase()=="franchisee")
        {
            alert("You Don't have rights!!!");
            return;
        }
        setMsg("");
        if(formData.abbr=="")
        {
            setMsg("Abbreviation is Missing!!!");
        }
        else if(formData.facilityid=="" || formData.facilityid=="0")
        {
            setMsg("Select Facility!!!");
        }
        else if(formData.name=="")
        {
            setMsg("Resource Name is Missing!!!");
        }
        else if(formData.rtype=="" || formData.rtype=="Resource Type")
        {
            setMsg("Select Resource Type!!!");
        }
        else if(window.confirm('Are you sure?'))        
        {            
            setProgress(true);
            let url="/api/Resource/SaveResource";            
            if(formData.id!="") url="/api/Resource/UpdateResource/"+formData.id;
            let datajson=JSON.stringify(formData);           
            //console.log(datajson);
                await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        alert("Data Saved Successfully");
                        setFormData({id:"",facilityid:"",abbr:"",name:"",description:"",ismeetingroom:"",rtype:"",photo1:"",photo2:"",photo3:""});
                        setShow(false);                        
                        loadMeetingRooms();
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                }); 
            setProgress(false);  
        }
    }
    async function loadMeetingRooms()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/MeetingRoom/GetAllMeetingRooms").then(res=>
        {
            if(res.status==200)
            {
                setResourceData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));                
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });                
        setProgress(false);
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=resourcedata.filter((e)=>e.facilityname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.details.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(resourcedata);                
                setPageData(resourcedata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=resourcedata.filter((e)=>e.facilityname==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...resourcedata]);
                setPageData(resourcedata.slice(0,pageSize));
            }
            setPage(1);
        }           
    }
    function readFileData(file)
    {
        const reader = new FileReader();
        reader.onload = (e) =>
         {
            const content = e.target.result;
            //setFileContent(content);
            //console.log("File content:", content);
        };
        // Choose how to read the file:
        // reader.readAsText(file);        // For text, JSON, CSV, etc.
        // reader.readAsDataURL(file);    // For images, to generate a preview URL
        reader.readAsText(file); // Example: Reading as text
    }
    function formValueChanged(event)
    {
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});
        if(event.target.id=="facilityid") setFormData({...formData,facilityid:event.target.value});
        if(event.target.id=="abbr") setFormData({...formData,abbr:event.target.value});
        if(event.target.id=="name") setFormData({...formData,name:event.target.value});
        if(event.target.id=="description") setFormData({...formData,description:event.target.value});
        if(event.target.id=="rtype")
        {
             if(event.target.value=="Meeting Room")
             {
                setFormData({...formData,rtype:event.target.value,ismeetingroom:"Y"});
             }
             else
             {
                setFormData({...formData,rtype:event.target.value,ismeetingroom:"N"});
             }
        }
        if(event.target.id=="photo1")
        {
            const { name, files } = event.target;
            if (!files || !files[0]) return;
            const reader = new FileReader();
            reader.onloadend = () =>
            {
                setFormData({...formData,photo1:reader.result});    
            };            
            reader.readAsDataURL(files[0]);        
         }
        if(event.target.id=="photo2")
        {
            const { name, files } = event.target;
            if (!files || !files[0]) return;
            const reader = new FileReader();
            reader.onloadend = () =>
            {
                setFormData({...formData,photo2:reader.result});    
            };            
            reader.readAsDataURL(files[0]);        
         }
        if(event.target.id=="photo3")
        {
            const { name, files } = event.target;
            if (!files || !files[0]) return;
            const reader = new FileReader();
            reader.onloadend = () =>
            {
                setFormData({...formData,photo3:reader.result});    
            };            
            reader.readAsDataURL(files[0]);        
         }
    }    
    async function deleteResource(id)
    {
        /*
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
           setProgress(true);
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/Resource/DeleteResource/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadMeetingRooms();                    
                }
            });
            setProgress(false);
        }*/
    }        
    function checkAbbr(event)
    {
        if(formData.facilityid=="0" || formData.facilityid=="")
        {
            alert("Select Facility!!!!");
            return;
        }
        if(event.target.value.trim()!="" && formData.facilityid!="0")
        {
            let data=resourcedata.find((e)=>e.facilityid==formData.facilityid && e.abbr.toUpperCase()==event.target.value.trim().toUpperCase());
            if(data)
            {
                setFormData({...formData,abbr:""});
                alert("This Abbreviation Already Exists in Selected Facility");                                
            }
        }
    }
    function sortData(colname)
    {
        let arr=[...dataToDisplay];
        arr.sort((e1,e2)=>
        {
            let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
            x=x*sortOrder;
            setsortOrder(sortOrder*-1);
            return x;
        }
        );                                    
        setDataToDisplay(arr);                        
        setPageData(arr.slice(0,pageSize));
        setPage(1);                
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadMeetingRooms();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">                    
                </div>                
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addResource} /></div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Meeting Rooms</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={`fac-${i}`} >{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}                            
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={`fac-${i}`}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    <td>{(ee.key=="photo1" || ee.key=="photo2" || ee.key=="photo3")?(<img src={e[ee.key]==""?noimage:e[ee.key]} width="30px" alt="" />):e[ee.key]}</td>                            
                                )}                                
                                <td className="text-center"><img onClick={()=>deleteResource(e.resourceid)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="4"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="4" className="text-center"></th>
                            <th colSpan="4" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="12">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Resources</div>                                    
                                        <input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/>
                                        <select className="form-control" id="facilityid" onChange={formValueChanged}>
                                            <option value="0">Select Facility</option>                                            
                                            {facilities.map((e, idx) => <option key={e.id} value={e.id}>{e.facilityname}</option>)}
                                        </select>
                                        <input type="text" id="abbr" onBlur={checkAbbr} onChange={formValueChanged} value={formData.abbr} className="form-control mt-2" placeholder="Resource Abbreviation" />                                    
                                        <input type="text" id="name" onChange={formValueChanged} value={formData.name} className="form-control mt-2" placeholder="Resource Name" />
                                        <input type="text" id="description" onChange={formValueChanged} value={formData.description} className="form-control mt-2" placeholder="Resource Description/Details" />
                                        <select className="form-control mt-2" id="rtype" onChange={formValueChanged}>
                                            <option value="Resource Type">Resource Type</option>
                                            <option value="Dedicated">Dedicated</option>
                                            <option value="Semi Private">Semi Private</option>
                                            <option value="POD">POD</option>
                                            <option value="Private Cabin">Private Cabin</option>
                                            <option value="Hot Destination">Hot Destination</option>
                                            <option value="Meeting Room">Meeting Room</option>                                            
                                        </select>
                                        <div className="rounded border p-2 mt-2">
                                            <h6>Photo 1</h6>
                                            <input type="file" accept="image/*" id="photo1" onChange={formValueChanged} value={formData.photo1} className="form-control mt-2"/>                                    
                                        </div>
                                        <div className="rounded border p-2 mt-2">
                                            <h6>Photo 2</h6>
                                            <input type="file" accept="image/*" id="photo2" onChange={formValueChanged} value={formData.photo2} className="form-control mt-2"/>                                    
                                        </div>
                                        <div className="rounded border p-2 mt-2">
                                            <h6>Photo 3</h6>
                                            <input type="file" accept="image/*" id="photo3" onChange={formValueChanged} value={formData.photo3} className="form-control mt-2"/>                                    
                                        </div>
                                    <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
const connectToStore=(state)=>({commonData:state});
export default connect(connectToStore)(MeetingRooms);